import { useState,useEffect } from '@wordpress/element';
import { GradientPicker} from '@wordpress/components';
import { VayuBlocksBlockEditor } from '@vayu-blocks/global';

const VayuBlocksGradients = (props) =>{
   const { colorPanel, attributeKey, onChange} = props;
      const index = colorPanel.findIndex(item => item.key === attributeKey);
       const colorData = colorPanel[index];
       const blockEditor = VayuBlocksBlockEditor();
       const [colors, setColors] = useState([]);
        
      useEffect(() => {
        setColors( [
          {
            gradients: blockEditor.gradients,
            name: 'THEME COLOR'
          }
        ]);
      
      },[blockEditor])


      const isGradient = (str) => {      
        const isLinearGradient = /^linear-gradient/i.test(str);
        const isRadialGradient = /^radial-gradient/i.test(str);
      
        if (isLinearGradient || isRadialGradient) {
            return str;
        } 
        // If the string is a hex color or the previous tab was 'gradient', set it to 'color'
        else{
          return null;
        }
      };
  

    return(<GradientPicker
           value={ isGradient(colorData.value) }
           onChange={(value)=>onChange(attributeKey,value) }
            gradients={colors}
            />)
}

export default VayuBlocksGradients; 